import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { ThemeProvider } from "./context/ThemeContext";
import AnnouncementBar from "./components/AnnouncementBar";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FloatingApply from "./components/FloatingApply";
import SearchModal from "./components/SearchModal";

import Home from "./pages/Home";
import About from "./pages/About";
import Academics from "./pages/Academics";
import Admissions from "./pages/Admissions";
import Research from "./pages/Research";
import Campus from "./pages/Campus";
import NewsEvents from "./pages/NewsEvents";
import DepartmentNewsEvents from "./pages/DepartmentNewsEvents";

// Inner About sub-pages
import AboutVDIT from "./pages/AboutVDIT";
import AboutKLS from "./pages/AboutKLS";
import ChairmansMessage from "./pages/ChairmansMessage";
import PrincipalsMessage from "./pages/PrincipalsMessage";
import Leadership from "./pages/Leadership";
import VisionMission from "./pages/VisionMission";
import OurHistory from "./pages/OurHistory";
import GoverningBodies from "./pages/GoverningBodies";
import People from "./pages/People";
import Committees from "./pages/Committees";
import Rules from "./pages/Rules";
import RTI from "./pages/RTI";
//import IQAC from "./pages/IQAC";
//import NIRF from "./pages/NIRF";
import MandatoryDisclosure from "./pages/MandatoryDisclosure";
import FinancialStatements from "./pages/FinancialStatements";

// Other inner pages
import ProgrammeDetail from "./pages/ProgrammeDetail";
import CSE from "./pages/departments/UG/CSE";
import CSEAIML from "./pages/departments/UG/CSEAIML";
import CSEAIDS from "./pages/departments/UG/CSEAIDS";
import ECE from "./pages/departments/UG/ECE";
import EEE from "./pages/departments/UG/EEE";
import Mechanical from "./pages/departments/UG/Mechanical";
import Civil from "./pages/departments/UG/Civil";
import BasicScience from "./pages/departments/UG/BasicScience";
import CSEInfrastructure from "./pages/departments/UG/CSEInfratsructure";
import AIMLInfrastructure from "./pages/departments/UG/AIMLInfrastructure";
import CivilInfrastructure from "./pages/departments/UG/CivilInfrastructure";
import ECEInfrastructure from "./pages/departments/UG/ECEInfrastructure";
import EEEInfrastructure from "./pages/departments/UG/EEEInfrastructure";
import MechanicalInfrastructure from "./pages/departments/UG/MechanicalInfrastructure";
import Physics from "./pages/departments/UG/Physics";
import Chemistry from "./pages/departments/UG/Chemistry";
import Maths from "./pages/departments/UG/Maths";
import English from "./pages/departments/UG/English";
import PhysicsInfrastructure from "./pages/departments/UG/PhysicsInfrastructure";
import ChemistryInfrastructure from "./pages/departments/UG/ChemistryInfrastructure";
import MathsInfrastructure from "./pages/departments/UG/MathsInfrastructure";
import EnglishInfrastructure from "./pages/departments/UG/EnglishInfrastructure";

import AIMLResources from "./pages/departments/UG/facultyData/StudentResources/AIMLResources";
import BSHResources from "./pages/departments/UG/facultyData/StudentResources/BSHResouces";
import CivilResources from "./pages/departments/UG/facultyData/StudentResources/CivilResources";
import CSEResources from "./pages/departments/UG/facultyData/StudentResources/CSEResources";
import ECEResources from "./pages/departments/UG/facultyData/StudentResources/ECEResources";
import EEEResources from "./pages/departments/UG/facultyData/StudentResources/EEEresources";
import MechanicalResources from "./pages/departments/UG/facultyData/StudentResources/MechanicalResources";
import PhysicsResources from "./pages/departments/UG/facultyData/StudentResources/PhysicsResources";
import ChemistryResources from "./pages/departments/UG/facultyData/StudentResources/ChemistryResources";
import MathematicsResources from "./pages/departments/UG/facultyData/StudentResources/MathematicsResources";
import EnglishResources from "./pages/departments/UG/facultyData/StudentResources/EnglishResources";

import IndustrialElectronics from "./pages/departments/PG/IndustrialElectronics";
import ThermalPowerEngineering from "./pages/departments/PG/ThermalPowerEngineering";
import IndustrialElectronicsFacilities from "./pages/departments/PG/IndustrialElectronicsFacilities";
import ThermalPowerFacilities from "./pages/departments/PG/ThermalPowerFacilities";
import CSEResearchCentre from "./pages/departments/ResearchCentres/CSEResearchCentre";
import ECEResearchCentre from "./pages/departments/ResearchCentres/ECEResearchCentre";
import EEEResearchCentre from "./pages/departments/ResearchCentres/EEEResearchCentre";
import MechanicalResearchCentre from "./pages/departments/ResearchCentres/MechanicalResearchCentre";
import PhysicsResearchCentre from "./pages/departments/ResearchCentres/PhysicsResearchCentre";
import ChemistryResearchCentre from "./pages/departments/ResearchCentres/ChemistryResearchCentre";
import MathematicsResearchCentre from "./pages/departments/ResearchCentres/MathematicsResearchCentre";
import Placements from "./pages/Placements";
import Library from "./pages/Library";
import LibraryInfrastructure from "./pages/LibraryInfrastructure";
import Alumni from "./pages/Alumni";
import Students from "./pages/Students";
import FacultyProfile from "./pages/FacultyProfile";
import NewsDetail from "./pages/NewsDetail";
import EventDetail from "./pages/EventDetail";
import Announcements from "./pages/Announcements";
import AnnouncementDetail from "./pages/AnnouncementDetail";
import StudentClubs from "./pages/StudentClubs";
import Associations from "./pages/Associations";
import Clubs from "./pages/Clubs";
import RedRibbonClub from "./pages/RedRibbonClub";
import RedCrossClub from "./pages/RedCrossClub";
import KalpavrukshaKannadaSangha from "./pages/KalpavrukshaKannadaSangha";
import Nss from "./pages/Nss";
import StandardsClub from "./pages/StandardsClub";
import CentreOfExcellence from "./pages/CentreOfExcellence";
import COEDetail from "./pages/COEDetail";
import COERoyalEnfieldInfrastructure from "./pages/COERoyalEnfieldInfrastructure";
import Sustainability from "./pages/Sustainability";
import AwardsRecognition from "./pages/AwardsRecognition";
import AssociationDetail from "./pages/AssociationDetail";
import IEIActivities from "./pages/IEIActivities";
import IEIFacultyMembers from "./pages/IEIFacultyMembers";
import IEIStudentMembers from "./pages/IEIStudentMembers";
import IeeeAboutUs from "./pages/IeeeAboutUs";
import IeeeEvents from "./pages/IeeeEvents";
import IeeeExecom from "./pages/IeeeExecom";
import CampusLifeDetail from "./pages/CampusLifeDetail";
import Hostels from "./pages/campus-life/Hostels";
import BoysHostel from "./pages/campus-life/BoysHostel";
import GirlsHostel from "./pages/campus-life/GirlsHostel";
import MessAndCanteen from "./pages/campus-life/MessAndCanteen";
import Transportation from "./pages/campus-life/Transportation";
import Atm from "./pages/campus-life/Atm";
import WifiCampus from "./pages/campus-life/WifiCampus";
import SolarRooftop from "./pages/campus-life/SolarRooftop";
import ComputerCenter from "./pages/campus-life/ComputerCenter";
import CooperativeSociety from "./pages/campus-life/CooperativeSociety";
import WeldingResearchCenter from "./pages/campus-life/WeldingResearchCenter";
import IITBombaySpokenTutorial from "./pages/campus-life/IITBombaySpokenTutorial";
import SportsGym from "./pages/campus-life/SportsGym";
import SportsGymInfrastructure from "./pages/campus-life/SportsGymInfrastructure";
import SportsAchievementDetail from "./pages/campus-life/SportsAchievementDetail";
import EcoClub from "./pages/campus-life/EcoClub";
import AICTE from "./pages/disclosure/AICTE";
import VTU from "./pages/disclosure/VTU";
import NAAC from "./pages/disclosure/NAAC";
import NIRF from "./pages/disclosure/NIRF";
import IQAC from "./pages/disclosure/IQAC";
import Governance from "./pages/disclosure/Governance";
import DELNET from "./pages/disclosure/DELNET";

const Forum = () => (
  <main className="max-w-5xl mx-auto px-6 lg:px-10 py-24 min-h-[60vh]">
    <h1
      className="text-4xl md:text-5xl text-brand font-semibold mb-4"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      VDIT Forum
    </h1>
    <p className="text-[#2a2a2a]/85 leading-relaxed">
      The VDIT Forum is a peer-reviewed publication featuring student and
      faculty perspectives on engineering, technology, and society. Issues are
      released bi-annually and are open access.
    </p>
  </main>
);

function App() {
  const [searchOpen, setSearchOpen] = React.useState(false);

  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <AnnouncementBar onSearchOpen={() => setSearchOpen(true)} />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            {/* About + sub */}
            <Route path="/about" element={<Navigate to="/about/about-kls" replace />} />
            <Route path="/about/about-kls" element={<AboutKLS />} />
            <Route path="/about/about-vdit" element={<AboutVDIT />} />
            <Route path="/about/chairmans-message" element={<ChairmansMessage />} />
            <Route path="/about/principals-message" element={<PrincipalsMessage />} />
            <Route path="/about/leadership" element={<Leadership />} />
            <Route path="/about/vision-mission" element={<VisionMission />} />
            <Route path="/about/our-history" element={<OurHistory />} />
            <Route path="/about/governing-bodies" element={<GoverningBodies />} />
            <Route path="/about/people" element={<People />} />
            <Route path="/about/committees" element={<Committees />} />
            <Route path="/about/rules" element={<Rules />} />
            <Route path="/about/rti" element={<RTI />} />
            <Route path="/about/iqac" element={<IQAC />} />
            <Route path="/about/nirf" element={<NIRF />} />
            <Route path="/about/mandatory-disclosure" element={<MandatoryDisclosure />} />
            <Route path="/about/financial-statements" element={<FinancialStatements />} />
            {/* Legacy About page */}
            <Route path="/about-legacy" element={<About />} />
            {/* Academics + departments */}
            <Route path="/academics" element={<Academics />} />
            <Route path="/programme/cse" element={<CSE />} />
            <Route path="/programme/cse/infrastructure" element={<CSEInfrastructure />} />
            <Route path="/programme/cse-aiml" element={<CSEAIML />} />
            <Route path="/programme/cse-aiml/infrastructure" element={<AIMLInfrastructure />} />
            <Route path="/programme/cse-aids" element={<CSEAIDS />} />
            <Route path="/programme/ece" element={<ECE />} />
            <Route path="/programme/ece/infrastructure" element={<ECEInfrastructure />} />
            <Route path="/programme/eee" element={<EEE />} />
            <Route path="/programme/eee/infrastructure" element={<EEEInfrastructure />} />
            <Route path="/programme/me" element={<Mechanical />} />
            <Route path="/programme/me/infrastructure" element={<MechanicalInfrastructure />} />
            <Route path="/programme/civil" element={<Civil />} />
            <Route path="/programme/civil/infrastructure" element={<CivilInfrastructure />} />
            <Route path="/programme/bsh" element={<BasicScience />} />
            <Route path="/programme/bsh/physics" element={<Physics />} />
            <Route path="/programme/bsh/physics/infrastructure" element={<PhysicsInfrastructure />} />
            <Route path="/programme/bsh/chemistry" element={<Chemistry />} />
            <Route path="/programme/bsh/chemistry/infrastructure" element={<ChemistryInfrastructure />} />
            <Route path="/programme/bsh/maths" element={<Maths />} />
            <Route path="/programme/bsh/maths/infrastructure" element={<MathsInfrastructure />} />
            <Route path="/programme/bsh/english" element={<English />} />
            <Route path="/programme/bsh/english/infrastructure" element={<EnglishInfrastructure />} />

            <Route path="/programme/cse/student-resources" element={<CSEResources />} />
            <Route path="/programme/cse-aiml/student-resources" element={<AIMLResources />} />
            <Route path="/programme/ece/student-resources" element={<ECEResources />} />
            <Route path="/programme/eee/student-resources" element={<EEEResources />} />
            <Route path="/programme/me/student-resources" element={<MechanicalResources />} />
            <Route path="/programme/civil/student-resources" element={<CivilResources />} />
            <Route path="/programme/bsh/student-resources" element={<BSHResources />} />
            <Route path="/programme/bsh/physics/student-resources" element={<PhysicsResources />} />
            <Route path="/programme/bsh/chemistry/student-resources" element={<ChemistryResources />} />
            <Route path="/programme/bsh/maths/student-resources" element={<MathematicsResources />} />
            <Route path="/programme/bsh/english/student-resources" element={<EnglishResources />} />
            <Route path="/programme/:id/news-events" element={<DepartmentNewsEvents />} />
            <Route path="/student-resources/physics" element={<Navigate to="/programme/bsh/physics/student-resources" replace />} />
            <Route path="/student-resources/chemistry" element={<Navigate to="/programme/bsh/chemistry/student-resources" replace />} />
            <Route path="/student-resources/mathematics" element={<Navigate to="/programme/bsh/maths/student-resources" replace />} />
            <Route path="/student-resources/english" element={<Navigate to="/programme/bsh/english/student-resources" replace />} />

            <Route path="/programme/industrial-electronics" element={<IndustrialElectronics />} />
            <Route path="/programme/industrial-electronics/facilities" element={<IndustrialElectronicsFacilities />} />
            <Route path="/programme/thermal-power-engineering" element={<ThermalPowerEngineering />} />
            <Route path="/programme/thermal-power-engineering/facilities" element={<ThermalPowerFacilities />} />
            <Route path="/programme/cse-research" element={<CSEResearchCentre />} />
            <Route path="/programme/cse-research-centre" element={<CSEResearchCentre />} />
            <Route path="/programme/ece-research" element={<ECEResearchCentre />} />
            <Route path="/programme/eee-research" element={<EEEResearchCentre />} />
            <Route path="/programme/me-research" element={<MechanicalResearchCentre />} />
            <Route path="/programme/physics" element={<PhysicsResearchCentre />} />
            <Route path="/programme/chemistry" element={<ChemistryResearchCentre />} />
            <Route path="/programme/mathematics" element={<MathematicsResearchCentre />} />
            <Route path="/programme/:id" element={<ProgrammeDetail />} />
            {/* Other top-level */}
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/research" element={<Research />} />
            <Route path="/campus" element={<Campus />} />
            <Route path="/campus-life/hostels" element={<Hostels />} />
            <Route
              path="/campus-life/Hostels"
              caseSensitive
              element={<Navigate to="/campus-life/hostels" replace />}
            />
            <Route path="/campus-life/boys-hostel" element={<BoysHostel />} />
            <Route path="/campus-life/girls-hostel" element={<GirlsHostel />} />
            <Route path="/campus-life/mess-and-canteen" element={<MessAndCanteen />} />
            <Route path="/campus-life/transportation" element={<Transportation />} />
            <Route path="/campus-life/atm" element={<Atm />} />
            <Route path="/campus-life/wifi-campus" element={<WifiCampus />} />
            <Route path="/campus-life/solar-rooftop" element={<SolarRooftop />} />
            <Route path="/campus-life/computer-center" element={<ComputerCenter />} />
            <Route path="/campus-life/cooperative-society" element={<CooperativeSociety />} />
            <Route path="/campus-life/welding-research-center" element={<WeldingResearchCenter />} />
            <Route path="/campus-life/iit-bombay-spoken-tutorial" element={<IITBombaySpokenTutorial />} />
            <Route path="/campus-life/sports-gym/infrastructure" element={<SportsGymInfrastructure />} />
            <Route path="/campus-life/:slug/:section" element={<CampusLifeDetail />} />
            <Route path="/news-events" element={<NewsEvents />} />
            <Route path="/placements" element={<Placements />} />
            <Route path="/library" element={<Library />} />
            <Route path="/library/infrastructure" element={<LibraryInfrastructure />} />
            <Route path="/alumni" element={<Alumni />} />
            <Route path="/students" element={<Students />} />
            <Route path="/forum" element={<Forum />} />
            <Route path="/associations" element={<Associations />} />
            <Route path="/associations/ieee/about-us" element={<IeeeAboutUs />} />
            <Route path="/associations/ieee/events" element={<IeeeEvents />} />
            <Route path="/associations/ieee/execom" element={<IeeeExecom />} />
            <Route path="/associations/iei/activities" element={<IEIActivities />} />
            <Route path="/associations/iei/faculty-members" element={<IEIFacultyMembers />} />
            <Route path="/associations/iei/student-members" element={<IEIStudentMembers />} />
            <Route path="/associations/:id" element={<AssociationDetail />} />
            <Route path="/clubs" element={<Clubs />} />
            <Route path="/clubs/red-ribbon" element={<RedRibbonClub />} />
            <Route path="/clubs/red-cross" element={<RedCrossClub />} />
            <Route path="/clubs/kalpavruksha" element={<KalpavrukshaKannadaSangha />} />
            <Route path="/clubs/eco-club" element={<EcoClub />} />
            <Route path="/clubs/nss" element={<Nss />} />
            <Route path="/clubs/standards" element={<StandardsClub />} />
            <Route path="/centre-of-excellence" element={<CentreOfExcellence />} />
            <Route path="/coe/royal-enfield-training-centre/infrastructure" element={<COERoyalEnfieldInfrastructure />} />
            <Route path="/coe/:id" element={<COEDetail />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/awards-recognition" element={<AwardsRecognition />} />
            <Route path="/faculty/:id" element={<FacultyProfile />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/event/:id" element={<EventDetail />} />
            <Route path="/announcements" element={<Announcements />} />

            <Route path="/announcement/:id" element={<AnnouncementDetail />} />
            <Route path="/student-clubs" element={<StudentClubs />} />
            {/* Disclosure */}
            <Route path="/aicte" element={<AICTE />} />
            <Route path="/vtu" element={<VTU />} />
            <Route path="/naac" element={<NAAC />} />
            <Route path="/nirf" element={<NIRF />} />
            <Route path="/iqac" element={<IQAC />} />
            <Route path="/governance" element={<Governance />} />
            <Route path="/delnet" element={<DELNET />} />
            {/* Life */}
            <Route path="/campus-life/sports-gym" element={<Navigate to="/campus-life/sports-gym/overview" replace />} />
            <Route path="/sports/achievements/:slug" element={<SportsAchievementDetail />} />

            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <FloatingApply />
          <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
